import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import EmployeeEditForm from '../components/EmployeeEditForm/EmployeeEditForm'
import * as api from '../utils/api/apiClient'
import { toast } from 'react-toastify'
import { Loading } from '../components/Loading'

const EmployeeDetails = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(false) // Manage loading state
  const [showForm, setShowForm] = useState(false)
  const [employeeDetails, setEmployeeDetails] = useState({})
  const [attendanceData, setAttendanceData] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [leaveTypes, setLeaveTypes] = useState([])
  // Attendance events state
  const [events, setEvents] = useState([])
  console.log('all event', events)

  const [currentDateRange, setCurrentDateRange] = useState({
    from: '',
    to: '',
  })

  const handleAddEmployee = () => {
    setShowForm((prevState) => !prevState)
  }

  const handleSuccessfulUpdate = () => {
    fetchEmployee()
    setShowForm(false)
  }

  // Attendance summary state
  const [attendanceSummary, setAttendanceSummary] = useState({})

  // Function to transform attendance data into calendar events
  const transformAttendanceToEvents = (attendanceData) => {
    return attendanceData.map((attendance) => {
      const eventDate = new Date(attendance.at).toISOString().split('T')[0]
      let eventColor = '#4caf50' // default green for entry

      // Corrected code: Convert attendance.at to a time string
      const eventTime = new Date(attendance.at).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // This ensures 12-hour format with AM/PM
      })

      // Create title with state and time
      let title = `${attendance.state.toUpperCase()} - ${eventTime}`

      // Add remark to title if it exists
      if (attendance.remark) {
        title += ` (${attendance.remark})`
      }

      // Set different colors based on state
      switch (attendance.state.toLowerCase()) {
        case 'entry':
          eventColor = '#4caf50' // green
          break
        case 'exit':
          eventColor = '#f44336' // red
          break
        default:
          eventColor = '#2196f3' // blue
      }

      return {
        title: title,
        start: eventDate,
        end: eventDate,
        backgroundColor: eventColor,
        borderColor: eventColor,
        textColor: '#ffffff',
        extendedProps: {
          post: attendance.post,
          remark: attendance.remark,
          state: attendance.state,
          time: new Date(attendance.at).toLocaleTimeString(),
        },
      }
    })
  }

  // Function to handle event click
  const handleEventClick = (info) => {
    const event = info.event
    const { post, remark, state, time } = event.extendedProps

    alert(`
      Time: ${time}
      Post: ${post}
      State: ${state}
      ${remark ? `Remark: ${remark}` : ''}
    `)
  }

  // ***********get employee Details****
  const fetchEmployee = async () => {
    try {
      const res = await api.getAEmployee(id)
      setEmployeeDetails(res?.data.employee)
    } catch (error) {
      console.log(error)
    }
  }

  const getCurrentMonthDates = () => {
    const now = new Date()
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

    return {
      from: formatDate(firstDay),
      to: formatDate(lastDay),
    }
  }

  const formatDate = (dateString) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString
    }
    const date = new Date(dateString)
    return date.toISOString().split('T')[0]
  }

  const handleDatesSet = (dateInfo) => {
    const startDate = formatDate(dateInfo.startStr)
    const endDate = formatDate(dateInfo.endStr)

    const date = new Date(startDate)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // Add padding to ensure 2 digits
    const monthYear = `${year}-${month}` // Format as "YYYY-MM"
    getMonthSummary(id, monthYear)

    setCurrentDateRange({
      from: startDate,
      to: endDate,
    })

    fetchAttendance(startDate, endDate)
  }

  const fetchAttendance = async (from, to) => {
    try {
      const res = await api.getOneAttendances(id, from, to)
      setAttendanceData(res.data)
      // Transform attendance data into events
      const calendarEvents = transformAttendanceToEvents(res.data)
      setEvents(calendarEvents)
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }

  // **********enroll Employee******************
  const postEmployee = async (id) => {
    try {
      const res = await api.enrollEmployee(id)
      console.log(res.data)
      toast.success('Add Enroll Successfully')
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    } finally {
      setIsOpen(false)
      fetchEmployee()
    }
  }

  // *************enroll delete function************
  const deleteEmployee = async (id) => {
    try {
      const res = await api.deleteEmployee(id)
      console.log(res.data)
      toast.success('delete Enroll Successfully')
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    } finally {
      setIsOpen(false)
      fetchEmployee()
    }
  }
  // **********get Leave Status function************
  const getLeave = async (id) => {
    try {
      const res = await api.getLeaveStatus(id)

      setLeaveTypes(res.data)
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }
  // **********get Monthly Summary function************

  const getCurrentMonthYear = () => {
    const now = new Date()
    const month = (now.getMonth() + 1).toString().padStart(2, '0') // Ensure two-digit month
    const year = now.getFullYear()

    return `${year}-${month}`
  }
  const getMonthSummary = async (id, month_year) => {
    try {
      const res = await api.getMonthlySummary(id, month_year)

      setAttendanceSummary(res.data)
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }
  const monthYear = getCurrentMonthYear() // Get current month-year in 'YYYY-MM' format

  useEffect(() => {
    if (id) {
      const { from, to } = getCurrentMonthDates()
      setCurrentDateRange({ from, to })
      fetchAttendance(from, to)
      fetchEmployee()
      getLeave(id)
      getMonthSummary(id, monthYear) // Call with month_year
    }
    setTimeout(() => {
      setLoading(true)
    }, 400) // 5 seconds
  }, [id])
  return (
    <div className='bg-cream p-3 sm:p-6 shadow-md mx-auto'>
      {/* Header */}
      {!loading && <Loading />}
      <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 pb-4 border-b border-tan gap-3 sm:gap-0'>
        <h1 className='font-bold text-xl sm:text-2xl text-brown'>
          Employee Details
        </h1>
        <div className='space-x-4'>
          <button
            onClick={() => {
              if (employeeDetails?.fingerprint_id < 0) {
                postEmployee(employeeDetails?.id)
                setIsOpen(true)
              } else {
                deleteEmployee(employeeDetails?.id)
                setIsOpen(true)
              }
            }}
            className='bg-muted_green hover:bg-opacity-80 transition-colors duration-300 py-2 px-4 rounded-md text-white'
          >
            {employeeDetails?.fingerprint_id < 0
              ? 'Enroll Now'
              : 'Delete Enroll'}
          </button>

          <button
            onClick={handleAddEmployee}
            className='bg-tan hover:bg-opacity-80 transition-colors duration-300 py-2 px-4 rounded-md text-white w-full sm:w-auto'
          >
            {showForm ? 'Close' : 'Edit'}
          </button>
        </div>
      </div>

      {/* Main Grid */}
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-8'>
        {/* Personal Details Section */}
        <div className='bg-white p-4 sm:p-6 rounded-lg shadow-sm'>
          <div className='flex flex-col sm:flex-row justify-between gap-4 sm:gap-0'>
            <div className='flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6'>
              <img
                src={
                  employeeDetails?.profile_pic ||
                  'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
                }
                alt='Employee'
                className='h-20 w-20 sm:h-24 sm:w-24 object-cover rounded-full border-4 border-tan'
              />
              <div className='text-center sm:text-left'>
                <h2 className='text-xl font-semibold capitalize text-brown'>
                  {employeeDetails?.name}
                </h2>
                <p className='text-black'>
                  Employee ID: {employeeDetails?.work_id}
                </p>
              </div>
            </div>
          </div>

          <div className='space-y-2 mt-6'>
            {[
              { label: 'Level', value: employeeDetails?.post },
              { label: 'Salary', value: employeeDetails?.salary },
              { label: 'Email', value: employeeDetails?.email },
              { label: 'Contact', value: employeeDetails?.phone_number },
              { label: 'Aadhar Number', value: employeeDetails?.aadhar },
              { label: 'PAN Number', value: employeeDetails?.pan_number },
              {
                label: 'Address',
                value: employeeDetails?.address,
              },
            ].map((item, index) => (
              <div
                key={index}
                className='flex flex-col sm:flex-row justify-between border-b border-light_gray pb-2 gap-1'
              >
                <span className='text-black font-medium'>{item.label}:</span>
                <span className='text-brown break-words sm:text-right'>
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Bank Details Section */}
        <div className='bg-white p-4 sm:p-6 rounded-lg shadow-sm'>
          <div className='border-b border-tan flex flex-col sm:flex-row justify-between mb-4 pb-2 gap-3 sm:gap-0'>
            <h2 className='text-xl font-semibold text-brown'>Bank Details</h2>
          </div>

          <div className='space-y-2'>
            {[
              { label: 'Bank Name', value: employeeDetails?.bank_name },
              {
                label: 'Account Number',
                value: employeeDetails?.account_number,
              },
              { label: 'IFSC Code', value: employeeDetails?.ifsc_code },
            ].map((item, index) => (
              <div
                key={index}
                className='flex flex-col sm:flex-row justify-between border-b border-light_gray pb-2 gap-1'
              >
                <span className='text-black font-medium'>{item.label}:</span>
                <span className='text-brown break-words sm:text-right'>
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Leave Details */}
      <div className='py-4 sm:py-6 mx-auto'>
        <div className='mt-6 sm:mt-8 bg-white p-4 sm:p-6 rounded-lg shadow-sm'>
          <div className='flex justify-between items-center mb-4 border-b border-tan pb-2'>
            <h2 className='text-xl font-semibold text-brown'>Leave Details</h2>
          </div>

          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
            {leaveTypes.map((leave, index) => (
              <div
                key={index}
                className='bg-cream p-4 rounded-lg border border-light_gray'
              >
                <h3 className='text-brown uppercase font-semibold mb-2'>
                  {leave.leave_type}
                </h3>
                <div className='space-y-2'>
                  <div className='flex justify-between'>
                    <span className='text-black'>Total Leave:</span>
                    <span className='text-brown'>
                      {leave.total_leaves} days
                    </span>
                  </div>
                  <div className='flex justify-between'>
                    <span className='text-black'>Used Leave:</span>
                    <span className='text-brown'>{leave.used_leaves} days</span>
                  </div>
                  <div className='flex justify-between'>
                    <span className='text-black'>Available Leave:</span>
                    <span className='text-brown font-bold'>
                      {leave.remaining_leaves} days
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Calendar Section */}
      <div className='mx-auto'>
        <div className='mt-6 sm:mt-8 bg-white p-4 sm:p-6 rounded-lg shadow-sm'>
          <div className='mb-4 border-b border-tan pb-2'>
            <h2 className='text-xl font-semibold text-brown'>
              Attendance Calendar
            </h2>
          </div>

          {/* Attendance leave Month Summary */}
          <div className='grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6'>
            {[
              {
                label: 'Present Days',
                value: attendanceSummary.present_days,
                color: 'text-brown',
              },
              {
                label: 'Absent Days',
                value: attendanceSummary.absent_days,
                color: 'text-olive',
              },
              {
                label: ' Casual Leaves',
                value: attendanceSummary.casual_leaves,
                color: 'text-link',
              },
              {
                label: 'medical leave Days',
                value: attendanceSummary.medical_leaves,
                color: 'text-error',
              },
              {
                label: 'Earned leaves',
                value: attendanceSummary.earned_leaves,
                color: 'text-error',
              },
              {
                label: 'Holidays',
                value: attendanceSummary.holidays,
                color: 'text-brown',
              },
              {
                label: 'Incomplete days',
                value: attendanceSummary.incomplete_days,
                color: 'text-error',
              },
              {
                label: 'total Work-hours',
                value: attendanceSummary.total_work_hours,
                color: 'text-error',
              },
            ].map((item, index) => (
              <div
                key={index}
                className='bg-cream p-3 sm:p-4 rounded-lg border border-light_gray text-center'
              >
                <h3 className='text-black font-medium mb-1 sm:mb-2 text-sm sm:text-base'>
                  {item.label}
                </h3>
                <span className={`text-xl sm:text-2xl font-bold ${item.color}`}>
                  {item.value}
                </span>
              </div>
            ))}
          </div>

          {/* FullCalendar Component */}
          <div className='overflow-x-auto'>
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView='dayGridMonth'
              events={events}
              eventClick={handleEventClick}
              datesSet={handleDatesSet}
              height='auto'
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,dayGridWeek,dayGridDay',
              }}
            />
          </div>
        </div>
      </div>

      {/* Modals */}
      {showForm && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4'>
          <div className='bg-white w-full max-w-4xl rounded-lg relative flex flex-col overflow-y-auto max-h-[90vh]'>
            <button
              onClick={handleAddEmployee}
              className='absolute top-4 right-4 text-2xl font-bold text-gray-600 hover:text-gray-900 z-10'
            >
              &times;
            </button>
            <div className='p-4 sm:p-6 overflow-y-auto'>
              <EmployeeEditForm
                id={employeeDetails.id}
                data={employeeDetails}
                onSuccess={handleSuccessfulUpdate}
              />
            </div>
          </div>
        </div>
      )}
      {/* enroll popups */}
      {isOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
          <div className='bg-white p-6 rounded-lg shadow-xl w-96'>
            <div className='flex items-center justify-center bg-cream p-4 '>
              <p className='text-xl mr-4 text-brown font-bold'>
                Enroll Updating...
              </p>
              <div className='relative'>
                <div className='h-24 w-24 rounded-full text-center  flex items-center justify-center'>
                  <img
                    src='https://upload.wikimedia.org/wikipedia/commons/1/10/Fingerprintforcriminologystubs.jpg'
                    width={50}
                    height={50}
                    alt='logo'
                    className='rounded-full '
                    priority // Helps improve loading performance
                  />
                </div>
                <div className='absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-tan animate-spin'></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EmployeeDetails
